import { DownloadOutlined, EyeOutlined, FilePdfOutlined, FileWordOutlined, SaveOutlined, CloseOutlined, SendOutlined, UploadOutlined, CheckOutlined, SyncOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Descriptions, Form, Input, Radio, Row, Select, Space, Tabs, Typography, Upload } from 'antd';
import type { UploadFile, UploadProps } from 'antd/es/upload/interface';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { ContentHeader } from '../../components';
import ModalTextForm from '../../components/modal/ModalTextForm';
import { maChucVu, trangThaiHopDongDienTu, urlAdmin } from '../../constants';
import { Link } from 'react-router-dom';
import { stringCommon, validateMessages } from '../../helpers/common';
import { ChiTietHopDongDienTuResponse, HopDongDienTu } from '../../models/hopdong/HopDong';
import { LogNguoiDung } from '../../models/lognguoidung/LogNguoiDung';
import { NhanVienResponse } from '../../models/nhanvien/NhanVien';
import { DataSelectBox } from '../../models/selectbox';
import { CauHinhHopDongFile } from '../../models/setting/Setting';
import { convertDataSelectBox, layDanhMucChucVu, layDanhMucLoaiHopDong, layDanhMucNhanVien } from '../../services/danhmuc';
import { layChiTietHopDongDienTu, laySoHopDongDienTu, luuHopDongDienTu, pheDuyetHopDongDienTu, taoHopDongDienTu, xemPdfHopDongDienTu } from '../../services/hopdong';
import { layCauHinhHopDong } from '../../services/setting';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import LogNguoiDungTable from '../utils/LogNguoiDungTable';
import TrangThaiHopDongDienTuTag from './TrangThaiHopDongDienTuTag';
import TatCaNhanVienSelectBox from '../utils/TatCaNhanVienSelectBox';
import { ApiPaths } from '../../helpers/api';
import { vgca_sign_approved } from '../../assets/vgcaplugin';
import { vgca_check_plugin } from '../../assets/vgcaplugin-config';
import { useNavigate } from 'react-router-dom';
import { Links } from '../../helpers/Links';
import LuuHopDongBox from './LuuHopDongBox';

const { Text } = Typography;
const { TextArea } = Input;

/// Nguồn tệp hợp đồng điện tử: hệ thống tạo sẵn từ tệp mẫu, hoặc người dùng tự tải tệp lên
const NGUON_FILE_MAC_DINH = 1;
const NGUON_FILE_TAI_LEN = 2;

/// Tệp do người dùng tải lên chỉ nhận Word hoặc PDF
const DS_DINH_DANG_CHO_PHEP = ['.doc', '.docx', '.pdf'];
const DUNG_LUONG_TOI_DA = 20000000; // 20 MB

const ChiTietHopDongDienTu = () => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const user = useSelector((state: any) => state.auth.currentUser);
    const [logs, setLogs] = useState<Array<LogNguoiDung>>([]);
    /// Nhân viên được truyền từ màn hình khác qua tham số idNhanVien trên URL
    const params = new URLSearchParams(window.location.search);
    const idNhanVienParam = parseInt(params.get('idNhanVien') ||'');
    const idHopDongCuParam = parseInt(params.get('idHopDongCu') || '0');
    /// Có tham số id nghĩa là mở lại hợp đồng điện tử đã lưu để xem/cập nhật
    const idParam = parseInt(params.get('id') || '0') || 0;
    /// Đã chỉ định nhân viên từ URL thì khóa lại, không cho chọn nhân viên khác
    const khoaNhanVien = idNhanVienParam > 0;

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isLoadingTaiFile, setIsLoadingTaiFile] = useState<boolean>(false);
    const [isLoadingLuu, setIsLoadingLuu] = useState<boolean>(false);
    const [isLoadingXemPdf, setIsLoadingXemPdf] = useState<boolean>(false);
    /// Id bản ghi đã lưu, có giá trị thì lần lưu sau là cập nhật chứ không thêm mới
    const [idHopDongDienTu, setIdHopDongDienTu] = useState<number>(idParam);
    /// Hợp đồng điện tử đã lưu, lấy theo tham số id trên URL
    const [chiTiet, setChiTiet] = useState<ChiTietHopDongDienTuResponse | null>(null);
    const [fileMau, setFileMau] = useState<CauHinhHopDongFile | null>(null);
    const [optionLoaiHopDong, setOptionLoaiHopDong] = useState<Array<DataSelectBox>>([]);
    const [optionChucDanh, setOptionChucDanh] = useState<Array<DataSelectBox>>([]);
    const [dsNhanVien, setDsNhanVien] = useState<Array<NhanVienResponse>>([]);
    /// Tệp Word/PDF người dùng tải lên, chỉ giữ lại một tệp
    const [fileTaiLen, setFileTaiLen] = useState<Array<UploadFile>>([]);
    /// Hộp xác nhận trước khi lưu, isTrinh để phân biệt Lưu với Lưu & Trình
    const [openModalLuu, setOpenModalLuu] = useState<boolean>(false);
    const [isTrinh, setIsTrinh] = useState<boolean>(false);
    /// Ý kiến người dùng nhập thêm, được ghi vào lịch sử thao tác
    const [lyDo, setLyDo] = useState<string>('');
    /// Hộp xác nhận của người ký nháy, isDuyet để phân biệt Phê duyệt với Từ chối
    const [openModalPheDuyet, setOpenModalPheDuyet] = useState<boolean>(false);
    const [isDuyet, setIsDuyet] = useState<boolean>(false);
    const [isLoadingPheDuyet, setIsLoadingPheDuyet] = useState<boolean>(false);
    const [kichHoatHD, setKichHoatHD] = useState<any>({});
    const giaTriForm = Form.useWatch([], form) || {};
    const nguonFile = giaTriForm.nguonFile || NGUON_FILE_MAC_DINH;
    const laTaiLen = nguonFile === NGUON_FILE_TAI_LEN;

    /// Các trường bắt buộc phải có thì hệ thống mới điền đủ tham số vào tệp mẫu
    const daNhapDuThongTin = !!(giaTriForm.idNhanVienKyNhay && giaTriForm.idNhanVien && giaTriForm.idLoaiHopDong
        && giaTriForm.ngayBatDau && giaTriForm.idChucVu && giaTriForm.diaDiemLamViec && giaTriForm.thoiGianLamViec);

    /// Tệp mẫu hợp đồng lao động đang được cấu hình
    const layFileMau = async () => {
        try {
            const cauHinh = await layCauHinhHopDong();
            setFileMau(cauHinh);
        } catch (err: any) {
            toast.error(err?.message || 'Đã xảy ra lỗi, không lấy được tệp mẫu hợp đồng lao động!');
        }
    };

    /// Danh mục loại hợp đồng lao động
    const layDsLoaiHopDong = async () => {
        try {
            const dsLoaiHopDong = await layDanhMucLoaiHopDong();
            setOptionLoaiHopDong(convertDataSelectBox(dsLoaiHopDong));
        } catch (err: any) {
            toast.error(err?.message || 'Đã xảy ra lỗi, không lấy được danh mục loại hợp đồng lao động!');
        }
    };

    /// Danh mục chức vụ, dùng để gợi ý vị trí/chức danh
    const layDsChucDanh = async () => {
        try {
            const dsChucVu = await layDanhMucChucVu();
            setOptionChucDanh(convertDataSelectBox(dsChucVu));
        } catch (err: any) {
            toast.error(err?.message || 'Đã xảy ra lỗi, không lấy được danh mục chức vụ!');
        }
    };

    /// Danh sách nhân viên, dùng để lấy họ tên hiển thị ở màn hình xem trước
    const layDsNhanVien = async () => {
        try {
            const rs = await layDanhMucNhanVien();
            setDsNhanVien(rs || []);
        } catch (err: any) {
            toast.error(err?.message || 'Đã xảy ra lỗi, không lấy được danh sách nhân viên!');
        }
    };

    /// Hợp đồng điện tử đã lưu, đổ ngược dữ liệu lên form để xem/cập nhật
    const layChiTiet = async (id: number) => {
        try {
            const rs = await layChiTietHopDongDienTu(id);
            setChiTiet(rs);
            setIdHopDongDienTu(rs.id);
            setLogs(rs.logs || []);
            form.setFieldsValue({
                idNhanVienKyNhay: rs.idNVKyNhay,
                idNhanVien: rs.idNhanVien,
                idLoaiHopDong: rs.idLoaiHopDong,
                idChucVu: rs.idChucVu,
                ngayBatDau: rs.ngayBatDau ? dayjs(rs.ngayBatDau) : null,
                ngayKetThuc: rs.ngayKetThuc ? dayjs(rs.ngayKetThuc) : null,
                thoiGianLamViec: rs.thoiGianLamViec,
                diaDiemLamViec: rs.diaDiemLamViec,
                nguonFile: rs.nguonFile || NGUON_FILE_MAC_DINH,
            });
        } catch (err: any) {
            toast.error(err?.message || 'Đã xảy ra lỗi, không lấy được thông tin hợp đồng điện tử!');
        }
    };

    /// Mỗi nguồn dữ liệu bắt lỗi riêng để một API lỗi không làm trống các ô còn lại
    const layDuLieu = async () => {
        dispatch(showLoadingScreen());
        setIsLoading(true);

        await Promise.all([
            layFileMau(),
            layDsLoaiHopDong(),
            layDsChucDanh(),
            layDsNhanVien(),
            idParam > 0 ? layChiTiet(idParam) : Promise.resolve(),
        ]);

        setIsLoading(false);
        dispatch(hideLoadingScreen());
    };

    /// beforeUpload trả về false nên tệp gốc nằm luôn trong fileList
    const layTepTaiLen = (): File | null => {
        const tep: any = fileTaiLen[0];
        return tep ? (tep.originFileObj || tep) : null;
    };

    /// Gom dữ liệu trên form thành tham số gửi cho API tạo hợp đồng điện tử
    const layThietLapTuForm = (values: any): HopDongDienTu => {
        const loaiHopDong = optionLoaiHopDong.find((item) => item.value === values.idLoaiHopDong);
        const chucVu = optionChucDanh.find((item) => item.value === values.idChucVu);
        const nhanVien = dsNhanVien.find((item) => item.id === values.idNhanVien);

        return {
            idTaiLieuMau: fileMau?.idTaiLieu || 0,
            idNhanVien: values.idNhanVien || 0,
            hoTen: nhanVien?.hoTen || '',
            idLoaiHopDong: values.idLoaiHopDong,
            tenLoaiHopDong: loaiHopDong?.label?.toString() || '',
            // API nhận kiểu DateTime nên phải gửi ISO, gửi dd/MM/yyyy sẽ bị lỗi 400 ngay khi đọc JSON
            ngayBatDau: values.ngayBatDau ? values.ngayBatDau.format('YYYY-MM-DD') : '',
            ngayKetThuc: values.ngayKetThuc ? values.ngayKetThuc.format('YYYY-MM-DD') : null,
            // API dùng IdChucVu để tra danh mục, tenChucVu chỉ để hiển thị ở màn hình xem trước
            idChucVu: values.idChucVu,
            tenChucVu: chucVu?.label?.toString() || '',
            thoiGianLamViec: values.thoiGianLamViec,
            diaDiemLamViec: values.diaDiemLamViec,
        };
    };

    /// Tên tệp do API đặt (HDLD_{họ tên}.docx) nằm trong header Content-Disposition
    const layTenTepTaiVe = (contentDisposition: string) => {
        const macDinh = 'HDLD.docx';
        if (!contentDisposition) {
            return macDinh;
        }

        // Tên tệp có dấu tiếng Việt được mã hóa ở filename*=UTF-8''..., filename= chỉ là bản dự phòng
        const utf8 = /filename\*=UTF-8''([^;]+)/i.exec(contentDisposition);
        if (utf8) {
            return decodeURIComponent(utf8[1]);
        }

        const thuong = /filename="?([^";]+)"?/i.exec(contentDisposition);
        return thuong ? thuong[1] : macDinh;
    };

    /// Gọi API điền dữ liệu vào các tham số {..} của tệp mẫu rồi tải tệp kết quả về
    const taiFileTuMau = async (duLieu: HopDongDienTu) => {
        try {
            dispatch(showLoadingScreen());
            setIsLoadingTaiFile(true);

            const response = await taoHopDongDienTu(duLieu);
            const link = document.createElement('a');
            link.download = layTenTepTaiVe(response.headers?.['content-disposition']);
            link.href = URL.createObjectURL(new Blob([response.data]));
            link.click();
            URL.revokeObjectURL(link.href);
        } catch (err: any) {
            toast.error(err?.message || 'Đã xảy ra lỗi, không tạo được tệp hợp đồng điện tử!');
        }
        setIsLoadingTaiFile(false);
        dispatch(hideLoadingScreen());
    };

    /// Bấm Phê duyệt / Từ chối chỉ mở hộp xác nhận để nhập thêm ý kiến
    const handlePheDuyet = (duyet: boolean) => {
        setIsDuyet(duyet);
        setOpenModalPheDuyet(true);
    };

    const dongModalPheDuyet = () => {
        setLyDo('');
        setOpenModalPheDuyet(false);
    };

    /// Người ký nháy duyệt thì chuyển cho người lao động ký, trả lại thì quay về người trình
    const submitPheDuyet = async () => {
        if (!chiTiet?.id) {
            return;
        }

        /// Trả lại thì bắt buộc nêu lý do để người trình biết phải sửa gì
        if (!isDuyet && !lyDo.trim()) {
            toast.warning('Vui lòng nhập lý do trả lại hợp đồng điện tử!');
            return;
        }

        try {
            dispatch(showLoadingScreen());
            setIsLoadingPheDuyet(true);

            await pheDuyetHopDongDienTu({ id: chiTiet.id, isDuyet: isDuyet, lyDo: lyDo });
            toast.success(isDuyet ? 'Phê duyệt hợp đồng điện tử thành công!' : 'Trả lại hợp đồng điện tử thành công!');

            /// Lấy lại chi tiết để cập nhật trạng thái và lịch sử thao tác
            dongModalPheDuyet();
            await layChiTiet(chiTiet.id);
        } catch (err: any) {
            toast.error(err?.message || 'Đã xảy ra lỗi, không xử lý được hợp đồng điện tử!');
        }
        setIsLoadingPheDuyet(false);
        dispatch(hideLoadingScreen());
    };
    /// Dựng tham số cho plugin ký số của Ban cơ yếu, số hợp đồng được đóng lên tệp qua DocNumber
    const goiPluginKySo = (soHopDong: string) => {
        var prms: any = {};
        var metaData = [
            { "Key": "Id", "Value": chiTiet?.id },
            { "Key": "Token", "Value": localStorage.getItem('token') },
            { "Key": "UserId", "Value": user.id },
            { "Key": "DocNumber", "Value": soHopDong },
            { "Key": "IssuedDate", "Value": new Date() },
        ];

        prms["FileUploadHandler"] = ApiPaths.hopDong.kySo;
        prms["SessionId"] = "";
        prms["MetaData"] = metaData;
        prms["FileName"] = ApiPaths.hopDong.xemPdfHopDongDienTu + "?id=" + chiTiet?.id;
        prms["IssuedDate"] = new Date();
        prms["DocNumber"] = soHopDong;
        var json_prms = JSON.stringify(prms);
        vgca_check_plugin(successKySo, fail, json_prms);
    }

    /// Nhân viên, người ký nháy và giám đốc ký trước khi ban hành nên hợp đồng có thể chưa có số
    const onKySo = async () => {
        if (!chiTiet?.id) {
            return;
        }

        dispatch(showLoadingScreen());
        goiPluginKySo(chiTiet.soHopDong || '');
    }

    /// Văn thư ban hành: lấy số hợp đồng của hệ thống (chưa có thì hệ thống cấp số) rồi mới đóng dấu
    const onBanHanh = async () => {
        if (!chiTiet?.id) {
            return;
        }

        dispatch(showLoadingScreen());
        let soHopDong = '';
        try {
            soHopDong = await laySoHopDongDienTu(chiTiet.id);
        } catch (err: any) {
            dispatch(hideLoadingScreen());
            toast.error(err?.message || 'Không lấy được số hợp đồng điện tử!');
            return;
        }

        goiPluginKySo(soHopDong);
    }

    const onKichHoatHopDong = async() => {
        await layChiTiet(chiTiet.id);
    }

    const successKySo = (json_prms: any) => {
        vgca_sign_approved(json_prms, callbackClosePluginKySo);
    }
    const callbackClosePluginKySo = async (rv: any) => {
        var received_msg = JSON.parse(rv);
        dispatch(hideLoadingScreen());
        if (received_msg.Status === 0) {
            if (stringCommon.isEmpty(received_msg.FileServer)) {
                toast.warning('Đã hủy bỏ quá trình ký.');
            } else {
                toast.success('Phê duyệt & Ký số thành công.');
                /// Ký xong trạng thái và tệp đều đổi nên phải lấy lại chi tiết
                await layChiTiet(idHopDongDienTu);
            }
        } else if (received_msg.Status === 14) {
            toast.warning('Đã hủy bỏ quá trình ký.');
        } else {
            toast.error('Ký không thành công.');
        }
    }
    const fail = (data: any) => {
        dispatch(hideLoadingScreen());
        toast.error('Vui lòng cài pluggin ký số của Ban cơ yếu');
    }
    /// Kiểm tra dữ liệu trước khi lưu, trả về null nếu chưa hợp lệ
    const kiemTraTruocKhiLuu = async (): Promise<any | null> => {
        let values: any;
        try {
            values = await form.validateFields();
        } catch (err: any) {
            /// Form chưa hợp lệ, antd đã tự đánh dấu lỗi ngay tại trường nhập
            return null;
        }

        if (values.nguonFile === NGUON_FILE_TAI_LEN) {
            /// Mở lại hợp đồng đã lưu bằng tệp tải lên mà không chọn tệp khác thì giữ nguyên tệp cũ
            const giuTepCu = idHopDongDienTu > 0
                && !!chiTiet?.tenTep
                && chiTiet?.nguonFile === NGUON_FILE_TAI_LEN;
            if (!layTepTaiLen() && !giuTepCu) {
                toast.warning('Vui lòng tải lên tệp hợp đồng điện tử định dạng Word hoặc PDF!');
                return null;
            }
        } else if (!fileMau) {
            toast.warning('Chưa cấu hình tệp mẫu hợp đồng lao động, vui lòng cấu hình trước khi lưu!');
            return null;
        }

        return values;
    };

    /// Dữ liệu hợp lệ mới mở hộp xác nhận, tránh bấm xác nhận xong mới báo thiếu thông tin
    const onBamLuu = async (trinh: boolean) => {
        const values = await kiemTraTruocKhiLuu();
        if (!values) {
            return;
        }

        setIsTrinh(trinh);
        setOpenModalLuu(true);
    };

    const dongModalLuu = () => {
        setLyDo('');
        setOpenModalLuu(false);
    };

    let navigate = useNavigate();
    /// Lưu hợp đồng điện tử kèm tệp hợp đồng vào bảng HOPDONGDIENTU
    const submitLuu = async () => {
        /// Kiểm tra lại vì người dùng còn sửa được form khi hộp xác nhận đang mở
        const values = await kiemTraTruocKhiLuu();
        if (!values) {
            setOpenModalLuu(false);
            return;
        }

        const tepTaiLen = layTepTaiLen();
        try {
            dispatch(showLoadingScreen());
            setIsLoadingLuu(true);

            const id = await luuHopDongDienTu({
                id: idHopDongDienTu,
                idNhanVien: values.idNhanVien,
                idNVKyNhay: values.idNhanVienKyNhay,
                idLoaiHopDong: values.idLoaiHopDong,
                idHopDongCu: idHopDongCuParam,
                idChucVu: values.idChucVu,
                isTrinh: isTrinh,
                lyDo: lyDo,
                // API nhận kiểu DateTime nên phải gửi ISO, gửi dd/MM/yyyy sẽ bị lỗi khi đọc dữ liệu
                ngayBatDau: values.ngayBatDau ? values.ngayBatDau.format('YYYY-MM-DD') : '',
                ngayKetThuc: values.ngayKetThuc ? values.ngayKetThuc.format('YYYY-MM-DD') : null,
                thoiGianLamViec: values.thoiGianLamViec,
                diaDiemLamViec: values.diaDiemLamViec,
                nguonFile: values.nguonFile,
                // Tệp mặc định do API tự tạo lại từ tệp mẫu nên không cần gửi kèm
                file: values.nguonFile === NGUON_FILE_TAI_LEN ? tepTaiLen : null,
            });
            toast.success(isTrinh ? 'Trình hợp đồng điện tử thành công' : 'Lưu hợp đồng điện tử thành công!');

            /// Lấy lại chi tiết để hiển thị đúng tệp vừa được lưu
            await layChiTiet(id);
            setFileTaiLen([]);
            dongModalLuu();
            if (!(idHopDongDienTu > 0)) {
                setIdHopDongDienTu(id);
                navigate(Links.HopDong.ChiTietHopDongDienTu + "?id=" + id);
            }
        } catch (err: any) {
            toast.error(err?.message || 'Đã xảy ra lỗi, không lưu được hợp đồng điện tử!');
        }
        setIsLoadingLuu(false);
        dispatch(hideLoadingScreen());
    };

    /// Tải ngay tệp hệ thống tạo từ tệp mẫu, không cần qua bước xem trước
    const onTaiFileMacDinh = async () => {
        if (!fileMau) {
            toast.warning('Chưa cấu hình tệp mẫu hợp đồng lao động, vui lòng cấu hình trước khi tải tệp!');
            return;
        }

        try {
            /// Chạy lại validate để chặn trường hợp dữ liệu đã nhập nhưng không hợp lệ
            const values = await form.validateFields();
            await taiFileTuMau(layThietLapTuForm(values));
        } catch (err: any) {
            /// Form không hợp lệ thì antd đã tự đánh dấu lỗi ngay tại trường nhập
        }
    };

    /// Tệp tải lên thay thế hoàn toàn tệp hệ thống tạo nên chỉ giữ một tệp
    const propsUpload: UploadProps = {
        accept: DS_DINH_DANG_CHO_PHEP.join(','),
        maxCount: 1,
        fileList: fileTaiLen,
        onRemove: () => setFileTaiLen([]),
        beforeUpload: (file) => {
            const dinhDang = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
            if (!DS_DINH_DANG_CHO_PHEP.includes(dinhDang)) {
                toast.warning('Tệp hợp đồng điện tử chỉ nhận định dạng Word (.doc, .docx) hoặc PDF (.pdf)!');
                return Upload.LIST_IGNORE;
            }
            if (file.size > DUNG_LUONG_TOI_DA) {
                toast.warning('Tệp hợp đồng điện tử không được vượt quá 20MB!');
                return Upload.LIST_IGNORE;
            }

            /// Trả về false để giữ tệp lại ở máy người dùng, chỉ gửi lên khi lưu
            setFileTaiLen([file]);
            return false;
        },
    };

    /// Tệp Word phải nhờ máy chủ chuyển sang PDF mới xem được trên trình duyệt
    const onXemPdf = async () => {
        if (!chiTiet?.id) {
            return;
        }

        /// Mở tab trước khi gọi API, mở sau khi await sẽ bị trình duyệt chặn cửa sổ bật lên
        const cuaSo = window.open('', '_blank');
        try {
            setIsLoadingXemPdf(true);

            const response = await xemPdfHopDongDienTu(chiTiet.id);
            /// Không thu hồi object URL vì tab mới còn đang đọc nội dung từ đường dẫn này
            const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            if (cuaSo) {
                cuaSo.location.href = url;
            } else {
                window.open(url, '_blank');
            }
        } catch (err: any) {
            cuaSo?.close();
            toast.error(err?.message || 'Đã xảy ra lỗi, không xem được bản PDF của hợp đồng!');
        }
        setIsLoadingXemPdf(false);
    };

    /// Biểu tượng theo định dạng tệp, Word và PDF dùng hai màu khác nhau cho dễ nhận biết
    const renderIconTep = (tenTep: string) => {
        return tenTep.toLowerCase().endsWith('.pdf')
            ? <FilePdfOutlined style={{ color: '#d4380d' }} />
            : <FileWordOutlined style={{ color: '#1554ad' }} />;
    };

    /// Tệp hợp đồng điện tử đang lưu của hợp đồng mở theo tham số id
    const renderTepDaLuu = (hienNhan: boolean = true) => {
        if (!chiTiet?.tenTep) {
            return null;
        }

        const urlTepDaLuu = urlAdmin + (chiTiet.duongDan || '').replace(/\\/g, '/');
        /// Chỉ tệp PDF mới xem thẳng trên trình duyệt được, tệp Word phải tải về máy để mở
        const laPdf = chiTiet.tenTep.toLowerCase().endsWith('.pdf');

        return (
            <div style={hienNhan ? { marginTop: 8 } : undefined}>
                <Space size={6} wrap>
                    {hienNhan && <Text type="secondary" style={{ fontSize: 12 }}>Tệp đang lưu:</Text>}
                    {renderIconTep(chiTiet.tenTep)}
                    <Text>{chiTiet.tenTep}</Text>
                    <Button type="primary"
                        size="small"
                        icon={<EyeOutlined />}
                        loading={!laPdf && isLoadingXemPdf}
                        onClick={() => laPdf ? window.open(urlTepDaLuu, '_blank') : onXemPdf()}>
                        Xem PDF
                    </Button>
                    <a href={urlTepDaLuu} download={chiTiet.tenTep}>
                        <Button className="hrm-btn hrm-btn-success" size="small" icon={<DownloadOutlined />}>Tải về</Button>
                    </a>
                </Space>
            </div>
        );
    };

    /// Tệp hợp đồng điện tử: mặc định hệ thống tạo từ tệp mẫu, hoặc người dùng tải tệp Word/PDF lên
    const renderFileHopDong = () => {
        if (laTaiLen) {
            return (
                <>
                    <Upload {...propsUpload}>
                        <Button type="primary" icon={<UploadOutlined />}>
                            {chiTiet?.tenTep ? 'Chọn tệp khác' : 'Chọn tệp Word hoặc PDF'}
                        </Button>
                    </Upload>
                    {renderTepDaLuu()}
                    <div style={{ marginTop: 4 }}>
                        <Text type="secondary" style={{ fontSize: 12 }}>
                            Chấp nhận .doc, .docx, .pdf và tối đa 20MB. Tệp tải lên được dùng nguyên trạng,
                            hệ thống không điền tham số vào tệp này.
                        </Text>
                    </div>
                </>
            );
        }

        if (!fileMau) {
            return (
                <Text type="danger" style={{ fontSize: 12 }}>
                    Chưa cấu hình tệp mẫu hợp đồng lao động, vui lòng cấu hình tệp mẫu hoặc chọn tải tệp lên.
                </Text>
            );
        }

        return (
            <>
                <Space size={6} wrap>
                    {renderIconTep(fileMau.tenTep)}
                    <Text>{fileMau.tenTep}</Text>
                    <Text type="secondary" style={{ fontSize: 12 }}>(hệ thống tạo từ tệp mẫu)</Text>
                </Space>
                {daNhapDuThongTin &&
                    <div style={{ marginTop: 8 }}>
                        <Button
                            className="hrm-btn hrm-btn-success"
                            icon={<DownloadOutlined />}
                            loading={isLoadingTaiFile}
                            onClick={onTaiFileMacDinh}>
                            Tải file hợp đồng (.docx)
                        </Button>
                    </div>}
                {renderTepDaLuu()}
            </>
        );
    };

    /// Danh mục nhân viên đã tải sẵn nên tra tên ngay tại chỗ, không gọi thêm API
    const layTenNhanVien = (id: number) => {
        return dsNhanVien.find((item) => item.id === id)?.hoTen || '';
    };

    /// Ngày trả về từ API ở dạng ISO, đưa về dd/MM/yyyy cho đồng bộ với các màn hình khác
    const dinhDangNgay = (ngay?: string | null) => {
        return ngay ? dayjs(ngay).format('DD/MM/YYYY') : '';
    };

    /// Hợp đồng đã trình thì không cho sửa nữa, chỉ hiển thị lại dữ liệu đã lưu
    const renderThongTinChiTiet = () => {
        if (!chiTiet) {
            return null;
        }

        /// Bản ghi chỉ lưu id nên phải tra ngược sang danh mục để lấy tên hiển thị
        const tenLoaiHopDong = optionLoaiHopDong.find((item) => item.value === chiTiet.idLoaiHopDong)?.label;
        const tenChucVu = optionChucDanh.find((item) => item.value === chiTiet.idChucVu)?.label;
        const chuaCo = (noiDung: string) => <Text type="secondary">{noiDung}</Text>;

        return (
            <Descriptions
                bordered
                size="small"
                column={{ xs: 1, sm: 1, md: 3 }}
                labelStyle={{ fontWeight: 600, width: 180 }}>
                <Descriptions.Item label="Nhân viên" span={1}>
                    {chiTiet.hoTen || layTenNhanVien(chiTiet.idNhanVien) || chuaCo('Không có dữ liệu')}
                </Descriptions.Item>
                <Descriptions.Item label="Số hợp đồng" span={1}>
                    {chiTiet.soHopDong || chuaCo('Chưa cấp số')}
                </Descriptions.Item>
                <Descriptions.Item label="Loại HĐLĐ" span={1}>
                    {tenLoaiHopDong || chuaCo('Không có dữ liệu')}
                </Descriptions.Item>
                <Descriptions.Item label="Chức vụ">
                    {tenChucVu || chuaCo('Không có dữ liệu')}
                </Descriptions.Item>
                <Descriptions.Item label="Ngày bắt đầu">
                    {dinhDangNgay(chiTiet.ngayBatDau) || chuaCo('Không có dữ liệu')}
                </Descriptions.Item>
                <Descriptions.Item label="Ngày kết thúc">
                    {dinhDangNgay(chiTiet.ngayKetThuc) || chuaCo('Không xác định')}
                </Descriptions.Item>
                <Descriptions.Item label="Người ký nháy">
                    {layTenNhanVien(chiTiet.idNVKyNhay) || chuaCo('Không có dữ liệu')}
                </Descriptions.Item>
                <Descriptions.Item label="Ngày ký">
                    {dinhDangNgay(chiTiet.ngayKy) || chuaCo('Chưa ký')}
                </Descriptions.Item>
                <Descriptions.Item label="Trạng thái" span={2}>
                    <TrangThaiHopDongDienTuTag value={chiTiet.trangThai} />
                </Descriptions.Item>
                <Descriptions.Item label="Địa điểm làm việc" span={2}>
                    {chiTiet.diaDiemLamViec || chuaCo('Không có dữ liệu')}
                </Descriptions.Item>
                <Descriptions.Item label="Thời gian làm việc" span={2}>
                    {chiTiet.thoiGianLamViec || chuaCo('Không có dữ liệu')}
                </Descriptions.Item>
                <Descriptions.Item label="File hợp đồng điện tử" span={2}>
                    {chiTiet.tenTep
                        ? renderTepDaLuu(false)
                        : chuaCo('Chưa có tệp hợp đồng điện tử')}
                </Descriptions.Item>
            </Descriptions>
        );
    };

    useEffect(() => {
        layDuLieu();
    }, []);
    const isEdit = chiTiet == null || (chiTiet.trangThai < trangThaiHopDongDienTu.trinhNguoiKyNhay && user.idNhanVien == chiTiet.idNVTheoDoi);

    const isLienKet = (chiTiet?.trangThai == trangThaiHopDongDienTu.hoanThanh && user.idNhanVien == chiTiet?.idNVTheoDoi);
    return <section>
        <ContentHeader title={idHopDongDienTu > 0 ? 'Chi tiết hợp đồng điện tử' : 'Thiết lập hợp đồng điện tử'} />
        {
            openModalLuu && <ModalTextForm show={openModalLuu}
                title={isTrinh ? "Trình hợp đồng điện tử" : idHopDongDienTu > 0 ? "Cập nhật hợp đồng điện tử" : "Thêm mới hợp đồng điện tử"}
                handleClose={dongModalLuu}
                handleSave={() => submitLuu()}>
                {isTrinh ?
                    <Row>
                        <Col span="24">
                            <span> Bạn có muốn <label>Trình</label> hợp đồng điện tử này không? Hãy nhập nội dung (nếu có):</span>
                        </Col>
                        <Col span="24">
                            <TextArea
                                autoSize={{ minRows: 2 }}
                                value={lyDo}
                                onChange={(e) => {
                                    setLyDo(e.target.value);
                                }}
                            />
                        </Col>
                    </Row> :
                    <span>  Bạn có muốn {idHopDongDienTu > 0 ? "cập nhật hợp đồng điện tử" : "tạo mới hợp đồng điện tử"} không?</span>
                }
            </ModalTextForm>
        }
        {
            openModalPheDuyet && <ModalTextForm show={openModalPheDuyet}
                title={isDuyet ? "Phê duyệt hợp đồng điện tử" : "Từ chối hợp đồng điện tử"}
                handleClose={dongModalPheDuyet}
                handleSave={() => submitPheDuyet()}>
                <Row>
                    <Col span="24">
                        {isDuyet ?
                            <span> Bạn có muốn <label>Phê duyệt</label> hợp đồng điện tử này để chuyển cho người lao động ký không? Hãy nhập nội dung (nếu có):</span> :
                            <span> Bạn có muốn <label>Trả lại</label> hợp đồng điện tử này cho người trình không? Hãy nhập lý do:</span>}
                    </Col>
                    <Col span="24">
                        <TextArea
                            autoSize={{ minRows: 2 }}
                            value={lyDo}
                            onChange={(e) => {
                                setLyDo(e.target.value);
                            }}
                        />
                    </Col>
                </Row>
            </ModalTextForm>
        }
        <Tabs defaultActiveKey="1"
            items={[
                {
                    key: "1",
                    label: "Thông tin hợp đồng",
                    children: <Row gutter={16}>
                        <Col span={24}>
                            <div className="card">
                                <div className="card-body">
                                    {isEdit ?
                                        <Form
                                            form={form}
                                            layout="vertical"
                                            validateMessages={validateMessages}
                                            initialValues={{
                                                idNhanVien: khoaNhanVien ? idNhanVienParam : undefined,
                                                nguonFile: NGUON_FILE_MAC_DINH,
                                                thoiGianLamViec: '8 giờ/ngày, thời gian làm việc cụ thể thực hiện theo Quy chế làm việc của Quỹ.',
                                                diaDiemLamViec: 'Số 18 Yên Bái, phường Hải Châu, thành phố Đà Nẵng'
                                            }}>
                                            <Row gutter={16}>
                                                <Col xs={24} md={12}>
                                                    <Form.Item name="idNhanVien" label="Nhân viên" rules={[{ required: true }]}>
                                                        <TatCaNhanVienSelectBox disabled={khoaNhanVien} onChange={(e: any) => {
                                                            form.setFieldValue('idNhanVien', e.target.value);
                                                        }} />
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} md={12}>
                                                    <Form.Item name="idLoaiHopDong" label="Loại HĐLĐ" rules={[{ required: true }]}>
                                                        <Select
                                                            options={optionLoaiHopDong}
                                                            loading={isLoading}
                                                            placeholder="Chọn loại hợp đồng lao động"
                                                            notFoundContent="Không có dữ liệu" />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row gutter={16}>
                                                <Col xs={24} md={12}>
                                                    <Form.Item name="ngayBatDau" label="Ngày bắt đầu" rules={[{ required: true }]}>
                                                        <DatePicker
                                                            changeOnBlur={true}
                                                            style={{ width: '100%' }}
                                                            placeholder="Ngày bắt đầu"
                                                            format={['DD/MM/YYYY', 'DDMMYYYY']} />
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} md={12}>
                                                    <Form.Item
                                                        name="ngayKetThuc"
                                                        label="Ngày kết thúc"
                                                        rules={[
                                                            ({ getFieldValue }) => ({
                                                                validator(_: any, value: any) {
                                                                    const ngayBatDau = getFieldValue('ngayBatDau');
                                                                    if (!value || !ngayBatDau || value.isAfter(ngayBatDau)) {
                                                                        return Promise.resolve();
                                                                    }
                                                                    return Promise.reject(new Error('Ngày kết thúc phải sau ngày bắt đầu!'));
                                                                },
                                                            }),
                                                        ]}>
                                                        <DatePicker
                                                            changeOnBlur={true}
                                                            style={{ width: '100%' }}
                                                            placeholder="Ngày kết thúc"
                                                            format={['DD/MM/YYYY', 'DDMMYYYY']}
                                                            disabledDate={(current) => {
                                                                const ngayBatDau = form.getFieldValue('ngayBatDau');
                                                                return !!ngayBatDau && !!current && current.isBefore(ngayBatDau, 'day');
                                                            }} />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row gutter={16}>
                                                <Col xs={24} md={12}>
                                                    <Form.Item
                                                        name="idChucVu"
                                                        label="Chức vụ"
                                                        rules={[{ required: true }]}>
                                                        <Select
                                                            showSearch
                                                            options={optionChucDanh}
                                                            loading={isLoading}
                                                            placeholder="Chọn chức vụ"
                                                            notFoundContent="Không có dữ liệu"
                                                            filterOption={(input, option) =>
                                                                (option?.label?.toString() || '').toLowerCase().includes(input.toLowerCase())} />
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} md={12}>
                                                    <Form.Item
                                                        name="diaDiemLamViec"
                                                        label="Địa điểm làm việc"
                                                        rules={[{ required: true }, { max: 500 }]}>
                                                        <Input allowClear placeholder="Địa điểm làm việc" />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row gutter={16}>
                                                <Col span={24}>
                                                    <Form.Item
                                                        name="thoiGianLamViec"
                                                        label="Thời gian làm việc"
                                                        rules={[{ required: true }, { max: 500 }]}>
                                                        <TextArea allowClear rows={2} placeholder="Thời gian làm việc" />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row gutter={16}>
                                                <Col xs={24} md={12}>
                                                    <Form.Item name="idNhanVienKyNhay" label="Người ký nháy" rules={[{ required: true }]}>
                                                        <TatCaNhanVienSelectBox nguoiKyNhay onChange={(e: any) => {
                                                            form.setFieldValue('idNhanVienKyNhay', e.target.value);
                                                        }} />
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} md={12}>
                                                    <Form.Item label="File hợp đồng điện tử" required>
                                                        <Form.Item name="nguonFile" noStyle>
                                                            <Radio.Group>
                                                                <Radio value={NGUON_FILE_MAC_DINH}>Mặc định của hệ thống</Radio>
                                                                <Radio value={NGUON_FILE_TAI_LEN}>Tải tệp lên</Radio>
                                                            </Radio.Group>
                                                        </Form.Item>
                                                        <div style={{ marginTop: 8 }}>{renderFileHopDong()}</div>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={24} style={{ textAlign: 'right' }}>
                                                    <Space>
                                                        <Button
                                                            type="primary"
                                                            icon={<SendOutlined />}
                                                            onClick={() => { onBamLuu(true) }}>
                                                            Lưu & Trình
                                                        </Button>
                                                        <Button
                                                            type="primary"
                                                            icon={<SaveOutlined />}
                                                            loading={isLoadingLuu}
                                                            onClick={() => { onBamLuu(false) }}>
                                                            Lưu
                                                        </Button>
                                                    </Space>
                                                </Col>
                                            </Row>
                                        </Form> :
                                        <>
                                            {renderThongTinChiTiet()}
                                            <Row style={{ marginTop: 16 }}>
                                                <Col span={24} style={{ textAlign: 'right' }}>
                                                    <Space>
                                                        {
                                                            user.idNhanVien == chiTiet.idNVKyNhay
                                                            && chiTiet.trangThai == trangThaiHopDongDienTu.trinhNguoiKyNhay
                                                            && 
                                                            <>
                                                                <Button
                                                                    type="primary"
                                                                    className="hrm-btn-delete"
                                                                    icon={<CloseOutlined />}
                                                                    loading={isLoadingPheDuyet}
                                                                    onClick={() => { handlePheDuyet(false) }}>
                                                                    Từ chối
                                                                </Button>
                                                                <Button
                                                                    type="primary"
                                                                    icon={<CheckOutlined />}
                                                                    loading={isLoadingPheDuyet}
                                                                    onClick={() => { handlePheDuyet(true) }}>
                                                                    Phê duyệt
                                                                </Button>
                                                            </>
                                                        }
                                                        {((user.idNhanVien == chiTiet.idNhanVien && chiTiet.trangThai == trangThaiHopDongDienTu.chuyenNhanVien) ||
                                                            (user.idNhanVien == chiTiet.idNVKyNhay && chiTiet.trangThai == trangThaiHopDongDienTu.chuyenNguoiKyNhay) ||
                                                            (user.maChucVu == maChucVu.giamDoc && chiTiet.trangThai == trangThaiHopDongDienTu.chuyenGiamDoc))
                                                            && <Button
                                                                className="hrm-btn hrm-btn-warning"
                                                                icon={<CheckOutlined />}
                                                                title="Ký số hợp đồng điện tử"
                                                                onClick={onKySo}>
                                                                Ký số
                                                            </Button>}
                                                        {
                                                            (user.maChucVu == maChucVu.vanThu && chiTiet.trangThai == trangThaiHopDongDienTu.chuyenVanThu)
                                                            && <Button
                                                                className="hrm-btn hrm-btn-warning"
                                                                icon={<CheckOutlined />}
                                                                title="Ban hành hợp đồng điện tử"
                                                                onClick={onBanHanh}>
                                                                Ban hành
                                                            </Button>}
                                                        {
                                                            isLienKet && chiTiet?.idHopDongMoi == 0 &&
                                                                <Button
                                                                className="hrm-btn hrm-btn-success"
                                                                icon={<SyncOutlined />}
                                                                title="Kích hoạt hợp đồng điện tử"
                                                                onClick={() => {
                                                                    setKichHoatHD({
                                                                        show: true,
                                                                        model: {
                                                                            "idHopDongDienTu": chiTiet?.id,
                                                                            "soHopDong": chiTiet?.soHopDong,
                                                                            "idLoaiHopDong": chiTiet?.idLoaiHopDong,
                                                                            "ngayKy": chiTiet?.ngayKy,
                                                                            "noiKy": "Quỹ Đầu tư phát triển thành phố Đà Nẵng",
                                                                            "ngayBatDau": chiTiet?.ngayBatDau,
                                                                            "ngayKetThuc": chiTiet?.ngayKetThuc,
                                                                            "idNhanVienKy": chiTiet?.idGiamDoc,
                                                                            "tenNguoiKy": chiTiet?.tenGiamDoc,
                                                                            "trangThai": 1
                                                                        }
                                                                    });
                                                                }}>
                                                                Kích hoạt
                                                            </Button>
                                                        }
                                                        {chiTiet?.idHopDongMoi > 0 && (
                                                            <Link
                                                                className="hrm-btn hrm-btn-success"
                                                                icon={<EyeOutlined />}
                                                                title="Xem hợp đồng nhân viên"
                                                                to={`${Links.HopDong.Xem}?id=${chiTiet?.idNhanVien}&idHopDong=${chiTiet?.idHopDongMoi}`}
                                                            >
                                                                Xem hợp đồng nhân viên
                                                            </Link>
                                                        )}
                                                    </Space>
                                                </Col>
                                            </Row>
                                        </>
                                    }

                                </div>
                            </div>
                        </Col>
                    </Row>
                },
                ...(logs.length > 0 ? [
                    {
                        key: '2',
                        label: "Lịch sử thao tác",
                        children: <LogNguoiDungTable data={logs} />
                    }
                ] : [])]} />

        {kichHoatHD?.show &&
            <LuuHopDongBox
                modelProps={kichHoatHD?.model}
                title="Kích hoạt hợp đồng điện tử"
                show={kichHoatHD?.show}
                idNhanVien={chiTiet?.idNhanVien}
                onClose={() => setKichHoatHD({
                    show: false,
                    model: {}
                })}
                onSubmit={() => onKichHoatHopDong()} />
        }
    </section>
};

export default ChiTietHopDongDienTu;
